/**
 * Dashboard options for the Home Page dropdown.
 * Shared across multiple components to maintain consistency.
 * Each entry maps a route path (value) to a human-readable label.
 * Add new pages here to make them available as a home-page destination.
 */
export const dashboardOptions = [
    { value: '/home', label: '-- System Default --' },
    { value: '/dashboards/executive-dash', label: 'Executive Dashboard' },
    { value: '/dashboards/operations-dash', label: 'Operations Dashboard' },
    { value: '/dashboards/footfall-dashboard', label: 'Footfall Dashboard' },
    { value: '/dashboards/sustainability-dashboard', label: 'Sustainability Dashboard' },
    { value: '/dashboards/finance-dashboard', label: 'Finance Dashboard' },
    { value: '/dashboards/arrears-dashboard', label: 'Arrears Dashboard' },
    { value: '/dashboards/leasing-dashboard', label: 'Leasing Dashboard' },
    { value: '/dashboards/legal-and-arrears-dashboard', label: 'Legal & Arrears Dashboard' },
    { value: '/dashboards/media-and-promotions-dashboard', label: 'Media & Promotions Dashboard' },
    { value: '/dashboards/csi-dashboard', label: 'CSI Dashboard' },
    { value: '/dashboards/itreport', label: 'IT Report' },
    { value: '/sipa/reports', label: 'SIPA Dashboard' },
    { value: '/operations/centremanager/home', label: 'Centre Manager Home' },
    { value: '/operations/cm-daily-checklist', label: 'Centre Manager Daily Checklist' },
    { value: '/it/monitoring/connectivity', label: 'Connectivity Monitoring' }
];
